// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import Vuex from "vuex"
Vue.use(Vuex)
Vue.config.productionTip = false;

import '../src/assets/js/jquery.min.js'
//数据请求
/**
 * 227服务器:justtest.iaskdr.com
 * 161服务器（正式线）:wyswx.iaskdr.com
 * 创联商_wxkay:wx92da1f7ae518b7ed    _ryToken:mgb7ka1nm47ng
 * 问壹声_wxkay:wx5fb97993ea2ae9ca    _ryToken:6tnym1br64yi7
 * */
import axios from 'axios';
Vue.prototype.$axios = axios;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; //post数据请求
Vue.prototype.wxToken = localStorage.getItem('ACCESS_TOKE');

/***************正式161**********************/
axios.defaults.baseURL = 'https://wyswx.iaskdr.com/'
Vue.prototype._wxKey = 'wx5fb97993ea2ae9ca';
Vue.prototype.appkey='6tnym1br64yi7';
Vue.prototype.img_url='https://dmyxpicfile.oss-cn-shanghai.aliyuncs.com';   // 正式：https://dmyxpicfile.oss-cn-shanghai.aliyuncs.com
Vue.prototype.fenxiangurl='https://wyswx.iaskdr.com/api/';
Vue.prototype.path='https://wyswx.iaskdr.com/api/';
Vue.prototype.fenxiang='https://wyswx.iaskdr.com';

/***************测试227**********************/
// axios.defaults.baseURL = 'https://justtest.iaskdr.com/'
// Vue.prototype._wxKey = 'wx92da1f7ae518b7ed';
// Vue.prototype.appkey='mgb7ka1nm47ng';
// Vue.prototype.img_url='https://devdmyxpicfile.oss-cn-shanghai.aliyuncs.com';   // 测试：https://devdmyxpicfile.oss-cn-shanghai.aliyuncs.com
// Vue.prototype.fenxiangurl='https://justtest.iaskdr.com/api/';
// Vue.prototype.path='https://justtest.iaskdr.com/api/';
// Vue.prototype.fenxiang='https://justtest.iaskdr.com';

Vue.prototype.pagesize = 8;
import configApi from '../src/assets/js/config.js';
Vue.prototype.configApi=configApi;
// 引入弹出框文件
import "../static/js/layer/skin/default/layer.css"
import "../static/js/layer/layer.js"
// import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
// let vConsole = new VConsole() // 初始化
//判断wxtoken是否存在缓存中，如果没有获取授权npm run build
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted: function () {
    if (this.configApi.getQueryString('sharetoken')) {
      var params = new URLSearchParams()
      params.append('wxToken', this.wxToken)
      params.append('sharetoken', this.configApi.getQueryString('sharetoken'))
      params.append('doctorId', '')
      this.$axios.post(
        '/api/consumer-doctor/doctor/doctor/bindDoctorNew',
        params,
      )
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js